/* Keep the WELCOME10 offer consistent after the popup redirects back to this page. */
(function () {
  var params = new URLSearchParams(window.location.search);
  if ((params.get('coupon') || '').toUpperCase() !== 'WELCOME10') return;

  var style = document.createElement('style');
  style.textContent = [
    '.geep-coupon-old{color:inherit;opacity:.55;text-decoration:line-through;text-decoration-thickness:.065em}',
    '.geep-coupon-new{color:inherit;font-weight:700}',
    '.geep-coupon-note{display:block;margin-top:9px;font:600 12px/1.4 Inter,Arial,sans-serif;letter-spacing:0;color:inherit;opacity:.83}',
    '.geep-coupon-note--dark{color:#315848;opacity:1}',
    '.page-geep-ring-offer__paper.is-coupon-active .page-geep-ring-offer__price{display:flex;align-items:baseline;flex-wrap:wrap;gap:10px}',
    '.page-geep-ring-offer__paper.is-coupon-active .page-geep-ring-offer__price .geep-coupon-old{font-size:.46em;font-weight:500;letter-spacing:-.02em}',
    '.page-geep-ring-offer__paper.is-coupon-active .page-geep-ring-offer__compare{display:none}',
    '.page-geep-ring-offer__paper.is-coupon-active .page-geep-ring-offer__coupon_price{margin-top:5px}',
    '.page-geep-ring-campaign-hero__price_line .geep-coupon-old{font-size:.54em;vertical-align:middle}',
    '@media(max-width:600px){.page-geep-ring-campaign-hero__price_line .geep-coupon-old{font-size:.46em}}'
  ].join('');
  document.head.appendChild(style);

  function one(selector) { return document.querySelector(selector); }
  function text(selector, value) {
    var node = one(selector);
    if (node) node.textContent = value;
    return node;
  }
  function html(selector, value) {
    var node = one(selector);
    if (node) node.innerHTML = value;
    return node;
  }
  function note(after, message, dark) {
    if (!after) return;
    var el = document.createElement('span');
    el.className = 'geep-coupon-note' + (dark ? ' geep-coupon-note--dark' : '');
    el.textContent = message;
    after.insertAdjacentElement('afterend', el);
  }

  text('.page-geep-ring-nav__nav_cta', 'Get the ring · about £80');
  html('.page-geep-ring-campaign-hero__price_line', '<s class="geep-coupon-old" aria-hidden="true">£89</s> <span class="geep-coupon-new">About £80</span>. Once.');
  text('.page-geep-ring-campaign-hero__hero_actions .page-geep-ring-campaign-hero__btn', 'Get the Geep Ring · about £80');
  note(one('.page-geep-ring-campaign-hero__hero_actions'), '10% code applied · £80.10 at checkout', false);

  text('.page-geep-ring-price-reason__eyebrow', 'Why Geep costs less');
  text('.page-geep-ring-included__eyebrow', 'Inside your Geep offer');

  var offer = one('.page-geep-ring-offer__paper');
  if (offer) {
    offer.classList.add('is-coupon-active');
    html('.page-geep-ring-offer__price', '<s class="geep-coupon-old" aria-hidden="true">£89</s> <strong class="geep-coupon-new">£80.10</strong> <small>once</small>');
    var couponPrice = offer.querySelector('[data-coupon-price]');
    if (couponPrice) {
      couponPrice.hidden = false;
      couponPrice.innerHTML = '<span>WELCOME10 applied · save £8.90</span>';
    }
    text('.page-geep-ring-offer__card_badge--save', '10% code applied');
    text('.page-geep-ring-offer__btn', 'Get the Geep Ring · £80.10');
  }

  var finalCopy = one('.page-geep-ring-final-cta__lead');
  if (finalCopy) finalCopy.textContent = finalCopy.textContent.replace(/£89 once/g, 'about £80 once');
  note(text('.page-geep-ring-final-cta__btn', 'Get the Geep Ring · about £80'), '10% code applied · £80.10 at checkout', false);
  text('.page-geep-ring-sticky-cta__sticky strong', 'Geep Ring · about £80');
  var facts = document.querySelectorAll('.page-geep-ring-agent-facts__row');
  for (var i = 0; i < facts.length; i++) {
    var label = facts[i].querySelector('dt');
    var value = facts[i].querySelector('dd');
    if (label && value && label.textContent.trim().toLowerCase() === 'price') {
      value.textContent = 'Regular price £89. With WELCOME10: £80.10 once. No monthly fee from Geep. Free UK delivery.';
    }
  }
})();
